<template>
    <input
        v-if="
            filter.current_shortcut_key != 'role_identity' &&
            filter.current_shortcut_key != 'station_identity' &&
            filter.current_shortcut_key != 'theme_name' &&
            filter.current_shortcut_key != 'is_banned'
        "
        @keypress.enter="$parent.$parent.$parent.staffs_filter()"
        v-model="filter.columns[filter.current_shortcut_key]"
        :placeholder="$t('ui.general.search__key', {
            key: $t('models.attributes.staffs.'+filter.current_shortcut_key)
        })"
        type="text"
    >

    <!--
    * ========================================================================
    * = 自行定義
    * ========================================================================
    -->
    <div
        v-else-if="filter.current_shortcut_key == 'role_identity'"
        class="ui selection fluid dropdown right_radius"
        style="min-width: 200px;"
        v-dropdown>
        <div class="text"
            v-for="role in roles"
            v-if="filter.columns.role_identity == role.identity">
            {{ role.name }}
        </div>
        <i class="dropdown icon"></i>
        <div class="menu">
            <div
                v-for="role in roles"
                @click="filter.columns.role_identity = role.identity"
                class="item"
                :class="{
                    'selected active': filter.columns.role_identity == role.identity
                }">
                {{ role.name }}
            </div>
        </div>
    </div>
    <div
        v-else-if="filter.current_shortcut_key == 'station_identity'"
        class="ui selection fluid dropdown right_radius"
        style="min-width: 200px;"
        v-dropdown>
        <div class="text"
            v-for="station in stations"
            v-if="filter.columns.station_identity == station.identity">
            {{ station.name }}
        </div>
        <i class="dropdown icon"></i>
        <div class="menu">
            <div
                v-for="station in stations"
                @click="filter.columns.station_identity = station.identity"
                class="item"
                :class="{
                    'selected active': filter.columns.station_identity == station.identity
                }">
                {{ station.name }}
            </div>
        </div>
    </div>
    <div
        v-else-if="filter.current_shortcut_key == 'theme_name'"
        class="ui selection fluid dropdown right_radius"
        style="min-width: 200px;"
        v-dropdown>
        <div class="text"
            v-for="theme_name in theme_names"
            v-if="filter.columns.theme_name == theme_name">
            <span v-if="theme_name">
                {{ $t('ui.theme_names.' + theme_name) }}
            </span>
            <span v-else>
                {{ $t('ui.general.please_select') }}
            </span>
        </div>
        <i class="dropdown icon"></i>
        <div class="menu">
            <div
                v-for="theme_name in theme_names"
                @click="filter.columns.theme_name = theme_name"
                class="item"
                :class="{
                    'selected active': filter.columns.theme_name == theme_name
                }">
                <span v-if="theme_name">
                    {{ $t('ui.theme_names.' + theme_name) }}
                </span>
                <span v-else>
                    {{ $t('ui.general.please_select') }}
                </span>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "StaffsFilterHeaderInputs",
    data() {
        return {
            is_initialized: false,
        }
    },
    computed: {
        current_store() {
            return this.$store.state.provider.staffs_module
        },
        filter() {
            return this.current_store.filter
        },
        theme_names() {
            return [null].concat(this.$store.state.provider.theme_menu_keys)
        },
        roles() {
            return [{
                name: this.$t('ui.general.please_select'),
                identity: null,
            }].concat(this.$store.state.provider.staffs_module.roles)
        },
        stations() {
            return [{
                name: this.$t('ui.general.please_select'),
                identity: null,
            }].concat(this.$store.state.provider.stations)
        },
    },
    created() {
    },
    mounted() {
    },
    watch: {
    },
    methods: {
    },
    components: {
    }
}
</script>
